var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90739 11.1886L8.70081 6.39658L8.25978 5.95508L2.71484 11.5005L8.25978 17.0455L8.70081 16.6049L3.90739 11.8116H19.6735V11.1886H3.90739Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5002 0C5.15886 0 0 5.15921 0 11.5011C0 17.8416 5.15886 23.0013 11.5002 23.0013C17.8416 23.0013 23 17.8416 23 11.5011C23 5.15921 17.8416 0 11.5002 0ZM11.5002 22.4572C5.45897 22.4572 0.543621 17.5423 0.543621 11.5009C0.543621 5.45838 5.45897 0.543031 11.5002 0.543031C17.5412 0.543031 22.4569 5.45838 22.4569 11.5005C22.4569 17.542 17.5412 22.4572 11.5002 22.4572Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoBack);
export default __webpack_public_path__ + "static/media/icon-go-back.4c61c82263369bbf99465becdfb7d6ee.svg";
export { ForwardRef as ReactComponent };